"use client";

import React from "react";
import Header from "@/components/shared/Header";
import Footer from "@/components/shared/Footer";

export default function AuthLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="relative h-screen flex flex-col bg-white text-gray-900" style={{ height: '100dvh' }}>
      <Header />
      
      <main className="flex-1 min-h-0 flex items-center justify-center px-6 md:px-12 py-8 md:py-12">
        <div className="w-full max-w-md">
          {children}
        </div>
      </main>
      <Footer variant="blue" bgColor="brand-blue"/>
    </div>
  );
}
